export enum SubscriptionType {
    Trial,
    Standard,
    Guest,
    Provider15,
    Provider50,
    Provider100,
    Embedded,
    Unknown
}

export interface SubscriptionCount {
    subscriptionType: SubscriptionType | "All",
    availableSubscriptions: number,
    usedSubscriptions: number
}

export interface DisplayedSubscriptionCount {
    type: SubscriptionType,
    available: number,
    used: number,
    total: number
}

export interface SearchedMembershipSubscription {
    readonly id: number;
    readonly userId: string;
    readonly type: SubscriptionType;
}
